module.exports = __webpack_public_path__ + "img/comment-empty-icon.e86bd87b.png";